export default __webpack_public_path__ + "static/media/chatBot-dark.82a22bf6.svg";